import React from 'react'
import './school-sign-up.scss'
import Dropdown from '../common/dropdown/dropdown'
import DropdownV2 from '../common/dropdown-v2/dropdown'
import DropdownV3 from '../common/dropdown-v3/dropdown'
import { Constants, ImageConstants } from '../../constants/constants'
import CommonUtils from '../../utility/common-utilities'
import { getImageSource } from '../../utility/image-source'
import PillButtonSelect from '../common/pill-button-select/pill-button-select'
import SchoolApi from '../../apis/school'
import CommonApi from '../../apis/common'
import Path from '../routes/routes-path'
import { Modal, ModalBody } from "reactstrap";

class SchoolSignUp extends React.Component {
  constructor(props) {
    super(props)
    this.state.classDropDownData = this.props.classes
      ? JSON.parse(JSON.stringify(this.props.classes))
      : []
    this.state.classes = this.props.classes?.map(c => {
      return c.title
    })
    this.state.rolesDropDownData = this.props.roles
      ? JSON.parse(JSON.stringify(this.props.roles))
      : []
    this.state.rolesDropDownData.length > 0 && this.state.rolesDropDownData.push({ title: "STUDENT", value: "STUDENT" })
    this.state.boardDropDownData = this.props.boards
      ? JSON.parse(JSON.stringify(this.props.boards))
      : []
    this.state.countryCodeDropDownData = this.props.countries
      ? JSON.parse(JSON.stringify(this.props.countries))
      : []
    this.state.hashedCountryCode = this.props.hashedCountryCode
      ? JSON.parse(JSON.stringify(this.props.hashedCountryCode))
      : []

    this.state.referrer = this.getParameterByName(
      'Ph',
      this.props?.location?.search
    )

    this.state.name = this.getParameterByName(
      'name',
      this.props?.location?.search
    )

    console.log(this.state.referrer)

  }

  /**
   * Get respective params from the provided URL
   * @param {*} name - Param name
   * @param {*} url - Provided URL
   */
  getParameterByName = (name, url) => {
    if (url) {
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return ''
  }

  componentDidMount() {
    let classes = this.props.classes?.map(c => {
      return c.title
    })
    this.getCities()
    this.onSelectPillButton(classes, 'class')
  }

  feeStructureDropDownData = [{ title: "20,000 - 59,000", value: "20,000 - 59,000" }, { title: "60,000 - 90,000", value: "60,000 - 90,000" }, { title: "90,000+", value: "90,000+" }]

  state = {
    schoolName: '',
    emailId: '',
    school: {},
    city: '',
    branch: '',
    board: [],
    classes: [],
    role: {},
    name: '',
    phoneNumber: '',
    countryCode: '+91',
    otp: '',
    isInvalidEmail: false,
    isSubmit: false,
    isOtpSubmit: false,
    isInvalidClass: false,
    isInvalidBoard: false,
    otpSend: false,
    isEmailAlreadyRegistered: false,
    isInvalidOTP: false,
    isExpiredOTP: false,
    isValidForm: false,
    isSignupSuccess: false,
    reloadDropdown: true,
    showRemoveButton: false,
    hoverIndex: -1,
    innerSelected: '',
    schoolPackage: "",
    packageDropdown: [
      { title: "Platinum (Rs.10,000/-)", value: "Platinum (Rs.10,000/-)" },
      { title: "Gold (Rs.6,500/-)", value: "Gold (Rs.6,500/-)" }
    ]
  }
  cityHash = {}

  getCities(payload = {}) {
    CommonApi.getCities(payload)
      .then(response => {
        let cities = response.response
        let citiesDropdown = []
        cities.forEach(element => {
          this.cityHash[element._id] = element

          let cityName = `${element.name}, ${element.state || element.country || ""}${element.state ? `, ${element.country}` : ""}`
          citiesDropdown.push({ title: cityName, value: element._id })
        });
        this.cityHash["OTHER"] = { name: "Others", state: "Other", country: "Other" }
        citiesDropdown.push({ title: "Others", value: "OTHER" })
        this.setState({ citiesDropdown, reloadDropdown: false })
      }).catch(err => {
      })
  }

  onCitySearch(value) {
    if (value.length >= 3) {
      let payload = { name: `/${value}` }
      this.getCities(payload)
    } else if (!value) {
      this.getCities()
    }
  }

  onChangeHandler = (event, key) => {
    this.setState({ [key]: event.target.value }, _ => {
      if (key === 'emailId') {
        this.setState({
          isEmailAlreadyRegistered: false,
          otpSend: false,
          isSubmit: false
        })
      }
      this.validatePayload()
    })
  }

  onSelect = (option, key) => {
    console.log(option, key)
    this.setState({ [key]: option?.value }, _ => {
      this.validatePayload()
      if (key === "city" && option?.value) {
        let cityInfo = this.cityHash[option?.value]
        if (cityInfo.countryCode) {
          this.setState({
            countryCode: cityInfo.countryCode
          }, _ => {
            if (this.countryCodeDropdownRef) {
              this.countryCodeDropdownRef.clearAll()
              if (this.props.hashedCountryCode && this.props.hashedCountryCode[cityInfo.countryCode]) {
                const countryCodeData = this.props.hashedCountryCode[cityInfo.countryCode]
                this.countryCodeDropdownRef.onClickOption({
                  title: `${countryCodeData.name} ${countryCodeData.dialCode}`,
                  addOn: countryCodeData.name,
                  value: countryCodeData.dialCode
                })
              }
            }
          })
        } else {
          this.setState({ countryCode: "", reloadCountryCode: true }, () => {
            this.setState({ reloadCountryCode: false })
          })
        }
      }
    })
  }

  onBlurEmailInput = event => {
    let value = event.target.value

    if (value) {
      let isValid = CommonUtils.validateEmail(event.target.value)
      if (!isValid)
        this.setState({ isInvalidEmail: true }, _ => {
          this.validatePayload()
        })
      else
        this.setState({ isInvalidEmail: false }, _ => {
          this.validatePayload()
        })
    } else {
      if (this.state.isInvalidEmail)
        this.setState({ isInvalidEmail: false }, _ => {
          this.validatePayload()
        })
    }
  }

  sendSchoolSignupOTP = _ => {
    this.setState({ showError: true })
    let isValid = this.validatePayload()

    if (!isValid) return
    this.setState({ isSubmit: true })
    const { emailId, schoolName, name, countryCode, phoneNumber } = this.state

    let payload = {
      email: emailId,
      school_name: schoolName,
      admin_name: name,
      country_code: countryCode,
      mobile_number: phoneNumber,
      eventParticipated: this.props.eventId ? [
        { eventId: this.props.eventId }
      ] : null
    }

    SchoolApi.sendSchoolSignupOTP(payload)
      .then(res => {
        if (res.status === 200) {
          this.setState({
            otpSend: true,
            isEmailAlreadyRegistered: false
          })
        }
      })
      .catch((err, res) => {
        if (err?.response?.data?.code === 11000) {
          this.setState({
            isEmailAlreadyRegistered: true
          })
        } else if (err?.response?.data?.message === 'Invalid email') {
          this.setState({
            isInvalidEmail: true
          })
        }
        this.setState({ isSubmit: false, isOtpSubmit: false })
      })
  }

  signUp = () => {
    this.setState({ isSubmit: true, isOtpSubmit: true })
    let isValid = this.validatePayload(true)

    if (!isValid) return

    const {
      schoolName,
      city,
      branch,
      board,
      classes,
      role,
      name,
      countryCode,
      phoneNumber,
      feeStructure,
      emailId,
      otp,
      referrer,
      schoolPackage,
      innerSelected
    } = this.state

    let cityInfo = this.cityHash[city]

    let payload = {
      name,
      schoolName,
      city: cityInfo.name,
      state: cityInfo.state,
      country: cityInfo.country,
      branch,
      board,
      classes,
      feeStructure,
      countryCode,
      phoneNumber,
      role,
      otp,
      referrer,
      email: emailId,
      // schoolPackage,
      // schoolAlreadyRegistered : innerSelected,
      eventParticipated: this.props.eventId ? [
        { eventId: this.props.eventId }
      ] : null
    }

    SchoolApi.createTemporarySchool(payload)
      .then(res => {
        this.setState(
          {
            isSignupSuccess: true
          },
          _ => {
            this.props.setSignupSuccess(name)
          }
        )
      })
      .catch(err => {
        if (err?.response?.data?.message) {
          const message = err?.response?.data?.message
          if (message === 'Incorrect OTP') {
            this.setState({
              isInvalidOTP: true
            })
          } else if (message === 'OTP has expired') {
            this.setState({
              isExpiredOTP: true
            })
          } else if (message === 'No OTP found for given email') {
            this.setState({
              isInvalidOTP: true
            })
          }
        } else if (
          err?.response?.status === 901 &&
          err?.response?.data?.message
        ) {
          this.validatePayload()
        }
        this.setState({ isSubmit: false, isOtpSubmit: false })
      })
  }

  validatePayload = isOTP => {
    this.setState({
      isValidForm: false,
      isNotAgree: false
    })
    let countryCodeDetail = this.state.hashedCountryCode[this.state.countryCode]
    let validateCountryCode = CommonUtils.validateMobileNumber(
      this.state.phoneNumber,
      countryCodeDetail
    )
    if (!validateCountryCode) {
      this.setState({ isInvalidMobile: true })
      return false
    } else {
      this.setState({ isInvalidMobile: false })
    }

    // if (!this.validateClass()) return false

    // if (!this.state.feeStructure) {
    //   this.setState({ isInvalidFeeStructure: false })
    //   return false
    // }

    if (!this.validateRole()) return false

    // if (!this.validateBoard()) return false

    if (!this.state.name) return false

    if (!this.state.emailId || this.state.isInvalidEmail) return false

    if (!this.state.schoolName) return false

    if (!this.state.countryCode) return false

    if (!this.state.phoneNumber.trim()) return false

    if (!this.state.role) return false

    if (!this.state.city) return false
    // if (!this.state.schoolPackage) return false
    // if (!this.state.innerSelected) return false

    // if (!this.state.branch) return false
    if (!this.state.isAccept) {
      this.setState({ isNotAgree: true })
      return false
    }
    if (!this.state.isAgree) {
      this.setState({ isNotAgree: true })
      return false
    }

    if (isOTP && !this.state.otp) return false
    this.setState({
      isValidForm: true
    })
    return true
  }

  validateClass = () => {
    let isClassSelected = true
    const { classes } = this.state

    if (!classes || classes.length < 1) isClassSelected = false

    if (!isClassSelected) this.setState({ isInvalidClass: true })
    else this.setState({ isInvalidClass: false })

    if (!isClassSelected) return false

    return true
  }

  validateBoard = () => {
    let isBoardSelected = true
    const { board } = this.state

    if (!board || board.length < 1) isBoardSelected = false

    if (!isBoardSelected) this.setState({ isInvalidBoard: true })
    else this.setState({ isInvalidBoard: false })

    if (!isBoardSelected) return false

    return true
  }

  validateRole = () => {
    const { role } = this.state
    let isRoleSelected = true

    if (!role.id || !role.title) isRoleSelected = false

    if (!isRoleSelected) this.setState({ isInvalidRole: true })
    else this.setState({ isInvalidRole: false })

    if (!isRoleSelected) return false

    return true
  }

  onSelectPillButton = (response, key) => {
    const res = response.map(r => {
      let obj = {
        name: r
      }
      return obj
    })
    if (key === 'class') {
      this.setState(
        {
          classes: res
        },
        _ => {
          this.validateClass()
        }
      )
    } else if (key === 'board') {
      this.setState(
        {
          board: res
        },
        _ => {
          this.validateBoard()
        }
      )
    }
  }

  onSelectFeeStructure(option) {

    if (option) this.setState({ feeStructure: { name: option } })
    else this.setState({ feeStructure: null })
  }

  openPopup = _ => {
    this.setState({
      openPopup: true
    })
  }
  onSelectRole = (option, index) => {
    if (option.value === 'STUDENT') {
      this.openPopup()
      if (this.dropdown) this.dropdown.resetSelectText();
      return
    }

    let role = { id: option.value, title: option.title }

    this.setState({ role }, () => {
      this.validateRole()
    })
  }

  removeSignUpfailedAlert = () => {
    this.props.delegate &&
      this.props.delegate.removeSignUpFailedMessage &&
      this.props.delegate.removeSignUpFailedMessage()
  }

  onFocusEmailInput = () => {
    if (this.props.isEmailAlreadyRegistered)
      this.props.delegate &&
        this.props.delegate.disableEmailIdAlreadyInUseErrorMsg &&
        this.props.delegate.disableEmailIdAlreadyInUseErrorMsg()
  }

  closeAppDownloadPopup = () => {
    this.setState({ openPopup: false, })
  }

  onClickLogin = () => {
    this.props.history.push(Path.LOGIN)
  }

  renderAppDownloadPopup() {
    return (
      <Modal
        className='cw-custom-modal'
        isOpen={true}
        toggle={this.closeAppDownloadPopup}
        size={'lg'}
      >
        <ModalBody>
          <div className=''>
            <div className='row'>
              <div className='col text-right'>
                <img
                  className='close-icon cursor-pointer'
                  onClick={this.closeAppDownloadPopup}
                  src={getImageSource(ImageConstants.CROSS)}
                />
              </div>
            </div>
            <div className='header-text text-center pt-4 px-3 py-3'>
              <span>
                This is a school registration form, Please download the Countingwell app for students registration
              </span>
            </div>
            <div className='px-4 py-4 text-center'>
              <a href="https://apps.apple.com/in/app/countingwell/id1508540117" target="_blank">
                <img
                  src={getImageSource(ImageConstants.IOS_DOWNLOAD)}
                  onClick={this.removeSignUpfailedAlert}
                  className='app-download-icon'
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.cwapp" target="_blank">
                <img
                  src={getImageSource(ImageConstants.ANDROID_DOWNLOAD)}
                  className='app-download-icon'
                />
              </a>
            </div>
            <div className="mt-4 text-center">
              <a href="https://countingwell.com" target="_blank">
                <span className='click-here'>KNOW MORE</span>
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  onClickAccept(key) {
    let value = this.state[key]
    this.setState({ [key]: !value }, () => {
      this.validatePayload()
    })
  }

  setSelectedStatus(value) {

    this.setState({ innerSelected: value })

  }

  render() {
    const {
      role,
      rolesDropDownData,
      classDropDownData,
      boardDropDownData,
      countryCodeDropDownData,
      isSubmit,
      isInvalidRole,
      countryCode,
      otpSend,
      schoolName,
      city,
      branch,
      board,
      classes,
      feeStructure,
      isInvalidBoard,
      isInvalidClass,
      isInvalidFeeStructure,
      name,
      phoneNumber,
      emailId,
      isInvalidEmail,
      isInvalidMobile,
      otp,
      isEmailAlreadyRegistered,
      isOtpSubmit,
      isInvalidOTP,
      isExpiredOTP,
      isSignupSuccess,
      showError,
      schoolPackage,
      innerSelected
    } = this.state
    return (
      <div className='sign-up center-box'>

        {/* {
          !isSignupSuccess ?
            <div className="text-right">
              <span className=""> Already registered? <span className="click-here-login ml-2" onClick={this.onClickLogin.bind(this)}>LOGIN </span></span>
            </div>
            : " "
        } */}
        {/* <div className='text-center my-auto pt-4  '>
          {!isSignupSuccess && (
            <div
              className='py-4 cursor-pointer are-u-student'
              onClick={_ => this.openPopup()}
            >
              <span>Are you a student? </span>
              <span className='click-here'> CLICK HERE</span>
            </div>
          )}
        </div> */}

        <div className='cw-card mb-5'>

          {!isSignupSuccess ?
            <div className="cw-card-header">
              Request For Demo
            </div> : ""
          }
          <div className='cw-card-body'>
            {this.props.isSignUpfailed && (
              <div className='row sign-up-failed-alert-space'>
                <div className='col'>
                  <div className='sign-up-failed-alert'>
                    <div className='row signup-failed-height'>
                      <div className='col-10 display-flex-center'>
                        <div className='pl-4'>
                          Signup failed. Please Signup again
                        </div>
                      </div>
                      <div className='col-2 display-flex-center justify-center cursor-pointer'>
                        <img
                          src={getImageSource(ImageConstants.REMOVE_CIRCLE)}
                          onClick={this.removeSignUpfailedAlert}
                          className='remove-icon'
                        ></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!isSignupSuccess && (
              <>
                <div className='row'>
                  <div className='col'>
                    <label className='cw-input-label'>YOUR NAME</label>
                    <input
                      className={`cw-input 
                                ${showError && !name ? 'invalid' : ''}`}
                      placeholder='Enter Your Name'
                      onChange={e => this.onChangeHandler(e, 'name')}
                      value={name}
                    />
                    {showError && !name && (
                      <span className='invalid-text'>Please enter name</span>
                    )}
                  </div>
                </div>

                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>ROLE</label>
                  </div>
                </div>
                <div className={`row position-relative`}>
                  <div className='col'>
                    <Dropdown
                      ref={instance => { this.dropdown = instance; }}
                      options={rolesDropDownData}
                      invalid={showError && !role.id}
                      onSelect={option => this.onSelectRole(option)}
                      value={role.id ? role.id : ''}
                      allOptions={this.props.roles}
                      style={{ background: '#F6F7F5' }}
                    />
                  </div>
                </div>
                {showError && isInvalidRole && (
                  <div className='row'>
                    <div className='col'>
                      {isInvalidRole && (
                        <span className='invalid-text'>Please select role</span>
                      )}
                    </div>
                  </div>
                )}
                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>
                      SCHOOL NAME
                      {/* <span className='star'>*</span> */}
                    </label>
                    <input
                      className={`cw-input ${showError && !schoolName ? 'invalid' : ''
                        }`}
                      placeholder='Enter Your School Name'
                      value={schoolName}
                      onChange={e => this.onChangeHandler(e, 'schoolName')}
                    />
                    {showError && !schoolName && (
                      <span className='invalid-text'>
                        Please enter school name
                      </span>
                    )}
                  </div>
                </div>

                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>CITY</label>
                    {!this.state.reloadDropdown ?
                      <DropdownV3
                        key='city-drop-down'
                        text='title'
                        placeholder='Select City'
                        searchable
                        options={this.state.citiesDropdown}
                        invalid={showError && !city}
                        onSelect={option => this.onSelect(option, 'city')}
                        value={city ? city : ''}
                        onSearch={value => this.onCitySearch(value)}
                        style={{ background: '#F6F7F5' }}
                      /> : ""
                    }

                    {showError && !city && (
                      <span className='invalid-text'>Please enter city</span>
                    )}
                  </div>
                </div>

                {/* <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>BRANCH</label>
                    <input
                      className={`cw-input ${showError && !branch ? 'invalid' : ''
                        }`}
                      placeholder='Enter Your Branch'
                      value={branch}
                      onChange={e => this.onChangeHandler(e, 'branch')}
                    />
                    {showError && !branch && (
                      <span className='invalid-text'>Please enter branch</span>
                    )}
                  </div>
                </div> */}

                {/* <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>SCHOOL BOARDS</label>
                  </div>
                </div>

                <div className={`row `}>
                  <div className='col'>
                    <PillButtonSelect
                      isMultiple
                      onSelect={value =>
                        this.onSelectPillButton(value, 'board')
                      }
                      options={boardDropDownData}
                      value={board}
                      style={{ width: '120px', fontSize: '14px' }}
                      invalid={showError && !board?.length}
                    />
                  </div>
                </div> */}

                {showError && isInvalidBoard && (
                  <div className='row'>
                    <div className='col'>
                      {isInvalidBoard && (
                        <span className='invalid-text'>Please enter board</span>
                      )}
                    </div>
                  </div>
                )}



                {/* <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>SELECT PACKAGE</label>
                    {!this.state.reloadDropdown ?
                      <DropdownV2
                        // key='city-drop-down'
                        text='title'
                        placeholder='Select Package'
                        // searchable
                        options={this.state.packageDropdown}
                        invalid={showError && !schoolPackage}
                        onSelect={option => this.onSelect(option, 'schoolPackage')}
                        value={schoolPackage ? schoolPackage : ''}
                        // onSearch={value => this.onCitySearch(value)}
                        allOptions = {this.state.packageDropdown}
                        style={{ background: '#F6F7F5' }}
                      /> : ""
                    }

                    {showError && !schoolPackage && (
                      <span className='invalid-text'>Please Select Package</span>
                    )}
                  </div>
                </div>

                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>Have you registered this school with Countingwell for any other event earlier?</label>
                    <div className='d-flex justify-content-around align-items-center'>
                      <div className='d-flex cursor-pointer' onClick={() => this.setSelectedStatus('Yes')}>
                        <div className={`circle mr-2 d-flex justify-content-center align-items-center`} >
                          <div className={` ${this.state.innerSelected === "Yes" ? "inner-selected" : ""}`}></div>
                        </div>
                        <div className='value-text'>Yes</div>
                      </div>
                      <div className='d-flex cursor-pointer' onClick={() => this.setSelectedStatus('No')}>
                        <div className={`circle mr-2 d-flex justify-content-center align-items-center`} >
                          <div className={` ${this.state.innerSelected === "No" ? "inner-selected" : ""}`}></div>
                        </div>
                        <div className='value-text'>No</div>
                      </div>
                    </div>

                    {showError && !innerSelected && (
                      <span className='invalid-text'>Please Select School Already Registered</span>
                    )}
                  </div>
                </div> */}


                {showError && isInvalidClass && (
                  <div className='row'>
                    <div className='col'>
                      {isInvalidClass && (
                        <span className='invalid-text'>
                          Please select class
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {/* <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>Fee Structure (₹)</label>
                  </div>
                </div>
                <div className={`row `}>
                  <div className='col'>
                    <PillButtonSelect
                      onSelect={value =>
                        this.onSelectFeeStructure(value, 'feeStructure')
                      }
                      options={this.feeStructureDropDownData}
                      value={feeStructure}
                      style={{ width: '130px', fontSize: '14px' }}
                      invalid={showError && !feeStructure}
                    />
                  </div>
                </div>
                {showError && isInvalidFeeStructure && (
                  <div className='row'>
                    <div className='col'>
                      {isInvalidFeeStructure && (
                        <span className='invalid-text'>
                          Please select fee structure
                        </span>
                      )}
                    </div>
                  </div>
                )} */}




                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>PHONE</label>
                  </div>
                </div>
                <div className='row phone-number-container'>
                  <div className='d-inline-block mr-2' style={{ width: '25%' }}>
                    {!this.state.reloadCountryCode ?
                      <DropdownV2
                        key='countryCode'
                        text='title'
                        placeholder='Select country code'
                        searchable
                        options={countryCodeDropDownData}
                        invalid={showError && !countryCode}
                        onSelect={option => this.onSelect(option, 'countryCode')}
                        value={countryCode ? countryCode : ''}
                        allOptions={this.props.countryCodeDropDownData}
                        onSearch={value => this.props.onCountryCodeSearch(value)}
                        style={{ background: '#F6F7F5' }}
                        ref={ref => this.countryCodeDropdownRef = ref}
                      />
                      : ""
                    }
                  </div>
                  <div className='d-inline-block' style={{ width: '70%' }}>
                    <input
                      className={`cw-input 
                      ${(isInvalidMobile && phoneNumber) ||
                          (showError && !phoneNumber)
                          ? 'invalid'
                          : ''
                        }`}
                      placeholder='Enter Your Phone Number'
                      onChange={e => this.onChangeHandler(e, 'phoneNumber')}
                      value={phoneNumber}
                    />
                  </div>
                  <div className='col'>
                    {showError && !phoneNumber && (
                      <span className='invalid-text'>
                        Please enter phone number
                      </span>
                    )}
                    {isInvalidMobile && phoneNumber && (
                      <span className='invalid-text'>
                        Enter valid phone number
                      </span>
                    )}
                  </div>
                </div>
                <div className='row bw-spaces-input'>
                  <div className='col'>
                    <label className='cw-input-label'>EMAIL ID</label>
                    <input
                      className={`cw-input 
                                ${(isInvalidEmail && emailId) ||
                          (showError && !emailId)
                          ? 'invalid'
                          : ''
                        }`}
                      placeholder='Enter Your Email Id'
                      onChange={e => this.onChangeHandler(e, 'emailId')}
                      onBlur={this.onBlurEmailInput}
                      onFocus={this.onFocusEmailInput}
                      value={emailId}
                      disabled={this.props.isProfile}
                    />

                    {isInvalidEmail && emailId && (
                      <span className='invalid-text'>Enter valid email</span>
                    )}
                    {showError && !emailId && (
                      <span className='invalid-text'>Please enter email</span>
                    )}
                    {isEmailAlreadyRegistered && (
                      <span className='invalid-text'>
                        The email is already in use. Please use a new email.{' '}
                      </span>
                    )}
                  </div>
                </div>
                {otpSend === true && (
                  <div className='row bw-spaces-input'>
                    <div className='col'>
                      <label className='cw-input-label'>OTP</label>
                      <input
                        className={`cw-input 
                                ${isOtpSubmit && !otp ? 'invalid' : ''}`}
                        placeholder={`Enter 6 digit code sent to ${emailId}`}
                        onChange={e => this.onChangeHandler(e, 'otp')}
                        value={otp}
                      />
                      {isOtpSubmit && !otp && (
                        <span className='invalid-text'>Please enter OTP</span>
                      )}
                      {isInvalidOTP && otp && (
                        <span className='invalid-text'>
                          Please enter valid OTP
                        </span>
                      )}
                      {isExpiredOTP && otp && (
                        <span className='invalid-text'>OTP Expired</span>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            {isSignupSuccess && (
              <div>
                <img
                  alt=""
                  src={getImageSource(ImageConstants.SIGNUP_SUCCESS_BANNER)}
                  className='success-banner'
                ></img>
              </div>
            )}
          </div>

          {!isSignupSuccess && !otpSend ?
            <div className="note px-4 py-2">
              <div className="row">
                <div className="col-1 px-0 text-right">
                  <img className={`check cursor-pointer `} alt="" onClick={() => this.onClickAccept("isAgree")} src={getImageSource(this.state.isAgree ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} />
                </div>
                <div className="col">
                  <i>You agree to be contacted via Email, Whatsapp or Text Messaging with updates and important information about your Countingwell account</i>
                </div>
              </div>
              <div className="row pt-2">
                <div className="col-1 px-0 text-right">
                  <img className={`check cursor-pointer `} alt="" onClick={() => this.onClickAccept("isAccept")} src={getImageSource(this.state.isAccept ? ImageConstants.RECT_TICK : ImageConstants.RECT_BLACK)} /></div>
                <div className="col"><i>By registering on Countingwell, you agree to the Terms of Conditions. <a className="tandc" target="_blank" href="https://countingwell.com/eula">Click here to view them in detail</a></i>
                </div>
              </div>
              {
                this.state.showError && this.state.isNotAgree ?
                  <div className="row pt-2">
                    <div className="col px-4">
                      <span className='invalid-text'>Please select above checkbox</span>
                    </div>
                  </div> : ""
              }
            </div>
            : ""
          }

          {!isSignupSuccess && (
            <>
              {otpSend === false ? (
                <div
                  className={`cw-card-footer ${this.state.isValidForm ? "" : "gray-footer"}`}
                  onClick={!isSubmit && this.sendSchoolSignupOTP}
                >
                  <span className='footer-text '>Request For Demo</span>
                </div>
              ) : (
                <div
                  className={`cw-card-footer ${!otp &&
                    'cw-card-footer-secondary'}`}
                  onClick={otp && otp.length === 6 && this.signUp}
                >
                  {!otp && (
                    <>
                      <p className='footer-text'>
                        Enter the 6 Digit OTP we have sent to your email and
                        Mobile.
                      </p>
                      <p className='footer-text'>
                        Check your SPAM folder in case it does not show in your
                        inbox
                      </p>
                    </>
                  )}{' '}
                  {otp && <span className='footer-text'>Submit</span>}
                </div>
              )}
            </>
          )}
        </div>
        {this.state.openPopup && this.renderAppDownloadPopup()}

      </div>
    )
  }
}

export default SchoolSignUp
